import React, {useState} from "react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/main/Breadcrumb';
import UIInput from 'components/input/input';
import Button from 'components/buttons/';
import { Tooltip } from "react-tooltip";
import CommonUtil from "utils/CommonUtil";
import StringUtil from "utils/StringUtil";
import UITextArea from "components/atoms/textarea/UITextArea";
import UIUtils from "../../../../utils/UIUtils";
import TbComFile from "domain/main/com/file/TbComFile";
import UI from "../../../../components/UI";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";
import codeDataStore from "../../../../common/codedata/store/CodeDataStore";
import use from "../../../../common/hooks/use";
import userRestRepository from "../../../../common/user/repository/UserRestRepository";
import ModalPopup from 'components/modal/';
import useToggleState from 'components/hooks/useToggleState';

/*import Raonkupload from 'components/input/kupload';*/
function ContentsContainer() {
	const [checked, setChecked] = useState(true);
	const checkHandled = ({target}) => {
		if (target.checked) {setChecked(true)} else {setChecked(false)}
	}

	const location = useLocation();
	const history = useHistory();
	const receivedData = (location.state as any)?.data;


	const [amtList, setAmtList] = React.useState<any[]>([{ SUPP_ITEM : '', CALC_BASIS : '', PROF_MATH : '', SUPP_AMT : ''}]);
	const [judgeList, setJudgeList] = React.useState<any[]>([]);
	const [judgeOtherList, setJudgeOtherList] = React.useState<any[]>([]);
	const [judgeDList, setJudgeDList] = React.useState<any[]>([]);
	const [judgeIList, setJudgeIList] = React.useState<any[]>([]);
	const [judgeUList, setJudgeUList] = React.useState<any[]>([]);
	const [corpList, setCorpList] = React.useState<any[]>([]);
	const [corpListText, setCorpListText] = React.useState('');
	const [tskReqNo,setTskReqNo] = useState(''); //과제번호
	const [TSK_REQ_NO,setTSK_REQ_NO] = useState(''); //과제번호
	const [tskReqModiSeq,setTskReqModiSeq] = useState(''); //과제수정번호
	const [subYn,setSubYn] = useState('N'); //제출여부
	const [cloYn,setCloYn] = useState('N'); //종료여부
	const [tskReqDate,setTskReqDate] = useState(''); //과제수정번호
	const [totalAmt, setTotalAmt] = useState(0); //금액 총액
	const [tskStDate,setTskStDate] = useState(''); //과제기간 시작
	const [tskEnDate,setTskEnDate] = useState(''); //과제기간 종료
	const [tskCloDate,setTskCloDate] = useState(''); //과제기간 종료
	const [tskPeriod,setTskPeriod] = useState(''); //과제기간 월일 표기
	const [bizKindNm1,setBizKindNm1] = useState(''); //과제분류 대
	const [bizKindNm2,setBizKindNm2] = useState(''); //과제분류 소
	const [foreTskYn, setForeTskYn] = useState('');
	const [suppContDivNm,setSuppContDivNm] = useState(''); //기금사용용도
	const [bizNm,setBizNm] = useState(''); //사업명
	const [tskNm,setTskNm] = useState(''); //과제명
	const [tskReqStsNm,setTskReqStsNm] = useState(''); //과제명
	const [tskReqStsCd,setTskReqStsCd] = useState(''); //과제명
	const [suppCorpCnt,setSuppCorpCnt] = useState(0); //중소기업 지원수
	const [otherSuppCorpCnt,setOtherSuppCorpCnt] = useState(0); //중소기업 외 지원수
	const [elecApprYn, setElecApprYn] = useState('');
	const [fileId, setFileId] = useState('');
	const [elec, setElec] = useState('');
	const [funPurUseNm, setFunPurUseNm] = useState('');
	
	//OZ 정보
	const [bizKindCd1, setBizKindCd1] = useState('');
	const [bizKindCd2, setBizKindCd2] = useState('');
	const [funPurUseCd, setFunPurUseCd] = useState('');
	const [hpNo, setHpNo] = useState('');
	const [ceoNm, setCeoNm] = useState('');
	const [corpSizeCd, setCorpSizeCd] = useState('');

	//밑에 담당자 정보
	const [corpNm,setCorpNm] = useState(''); //과제명
	const [bizNo,setBizNo] = useState(''); //사업자번호
	const [bizCd,setBizCd] = useState(''); //사업코드
	const [corpRegNo,setCorpRegNo] = useState(''); //사업자번호
	const [personNm,setPersonNm] = useState(''); //이름
	const [posiNm,setPosiNm] = useState(''); //직급
	const [deptNm,setDeptNm] = useState(''); //부서명
	const [emailAdres,setEmailAdres] = useState(''); //이메일
	const [ofcTelNo,setOfcTelNo] = useState(''); //전화번호


	const [suppCont,setSuppCont] = useState(''); //지원내용, 과제개요 // as-is, to-be
	const [exeEffDesc,setExeEffDesc] = useState(''); //기대효과, 정성내용 // as-is, to-be
	const [qList,setQList] = useState({ //기대효과 14문항
		q1: '', q2: '', q3: '', q4: '', q5: '', q6: '', q7: '',
		q8: '', q9: '', q10: '', q11: '', q12: '', q13: '', q14: ''
	});

	const [queList,setQueList] = useState<any>([]);

	// REQ - 신청서, PLAN - 계획서, 수행기관 사업자 등록증 - BIZ
	const [reqFileValue] = useState(new TbComFile());
	const [planFileValue] = useState(new TbComFile());
	const [bizFileValue] = useState(new TbComFile());
	const [fileValue] = useState(new TbComFile());

	const [addAmtList, setAddAmtList] = React.useState<any[]>([{ ADD_SUPP_ITEM : '', ADD_CALC_BASIS : '', ADD_PROF_MATH : '', ADD_SUPP_AMT : ''}]);//추가과제심사금액
	const [addTotalAmt, setAddTotalAmt] = useState(0); //추가과제심사금액 총액
	
	const modalusr2107p = useToggleState({});
	const [judgeCmt,setJudgeCmt] = useState(''); //심사코멘트
	
	function dateToStr(dateText) {

		if(dateText == null) return '';

		if(/^(-?)[0-9]+$/.test(dateText)){
			dateText = Number(dateText);
		}
		let date = new Date(dateText);
		let week = new Array('일', '월', '화', '수', '목', '금', '토');


		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();
		let dayName = week[date.getDay()];

		return year+'-'+dateLpad(month)+'-'+dateLpad(day)+'('+dayName+')';
	}

	function dateLpad(num){
		if(num.toString().length == 1){
			num = "0"+num;
		}

		return num;
	}

	//문서 제출시
	async function updateSub(){
		//파일업로드 작업 후 추가해야함
		/*필수서류가 누락되었습니다.
		파일첨부 후 제출해 주세요.*/

		if(tskReqStsCd == 'E'){
			if(judgeUList.length == 0){
				await UIUtils.alert(<>수정 이력이 존재하지 않아 제출할 수 없습니다.</>);
				return false;
			}
		}

		if(elecApprYn == 'N'){
			if(reqFileValue.tbComFileMapngDetailList.length == 0){
				await UIUtils.alert(<>필수서류가 누락되었습니다.<br/> 파일첨부 후 제출해 주세요.</>);
				return false;
			}
		}

		if(planFileValue.tbComFileMapngDetailList.length == 0){
			await UIUtils.alert(<>필수서류가 누락되었습니다.<br/> 파일첨부 후 제출해 주세요.</>);
			return false;
		}



		if(await UIUtils.confirm('제출하시겠습니까?')){
			let param = {
				TSK_REQ_NO : tskReqNo,
				TSK_REQ_MODI_SEQ : tskReqModiSeq,
				JUDGE_CMT : judgeCmt,
				TSK_REQ_STS_CD : tskReqStsCd
			};

			const response:any = await CommonUtil.execute({
				url:'tskJudgeUpdate',
				data: param
			})

			if (!response.COMMON_HEAD.ERROR) {
				setSubYn('제출');
				UIUtils.alert('정상처리되었습니다.').then();
				// 다른 페이지로 이동하면서 데이터 전달
				history.push({
					pathname: './usr_2105',
					state: { data: JSON.parse(receivedData.vAll_PARAM) }
				});
			}
		}

	}

	//변경심사
	async function copyTsk(){
		//지급신청건이 있어서 변경심사를 진행할 수 없습니다.
		if(await UIUtils.confirm('변경심사를 진행하시겠습니까?')){

			const response:any = await CommonUtil.execute({
				url:'usr_2107_tsk_pay_chk',
				data: {TSK_REQ_NO : tskReqNo}
			}).then((response: any) => {
				if(response.REC.length == 0){
					let param = {
						TSK_REQ_NO : tskReqNo,
						TSK_REQ_MODI_SEQ : tskReqModiSeq
					}

					const response2:any = CommonUtil.execute({
						url:'usr_2107_copy_tsk',
						data: param
					}).then((response: any) => {
						let vTSK_REQ_NO = tskReqNo;
						let vTSK_REQ_MODI_SEQ = tskReqModiSeq+1;

						let dataToSend = {vTSK_REQ_NO,vTSK_REQ_MODI_SEQ,vAll_PARAM:receivedData.vAll_PARAM};
						UIUtils.alert('정상처리되었습니다.').then(()=>{
							// 다른 페이지로 이동하면서 데이터 전달
							history.push({
								pathname: './usr_2105',
								state: { data: dataToSend }
							});
						});
					}).catch((error) => {
						CommonUtil.showAxiosError(error);
						return;
					});

				}else{
					UIUtils.alert('지급신청건이 있어서 변경심사를 진행할 수 없습니다.');
				}
				return;
			}).catch((error) => {
		    	CommonUtil.showAxiosError(error);
		    	return;
	       	});
		}

	}

	//과제삭제
	async function deleteTsk(action){
		let msg = '취소하시겠습니까?';
		if(action == 'D') msg = '삭제하시겠습니까?';
		if(await UIUtils.confirm(msg)){
			let param = {
				TSK_REQ_NO : tskReqNo,
				TSK_REQ_MODI_SEQ : tskReqModiSeq,
				BIZ_NO : bizNo,
				BIZ_CD : bizCd,
				TYPE : action
			};

			const response:any = await CommonUtil.execute({
				url:'usr_2107_delete',
				data: param
			})

			if (!response.COMMON_HEAD.ERROR) {
				UIUtils.alert('정상처리되었습니다.').then(()=>{
					// 다른 페이지로 이동하면서 데이터 전달
					history.push({
						pathname: './usr_2105',
						state: { data: JSON.parse(receivedData.vAll_PARAM) }
					});
				});
			}
		}

	}

	async function saveJudge(judgeTp){

		let param = {
			TSK_REQ_NO : tskReqNo,
			TSK_REQ_MODI_SEQ : tskReqModiSeq,
			JUDGE_TP : judgeTp,
		};

		const response:any = await CommonUtil.execute({
			url:'tskJudgeRcept',
			data: param
		})
	}


	async function initCall(){

		let param1 = {TSK_REQ_NO : receivedData.vTSK_REQ_NO};

		const response1:any = await CommonUtil.execute({
			url:'tsk_que_list',
			data: param1
		})

		const result1 = response1;
		setQueList(result1.REC);
		console.log(result1)

		let param = {
			TSK_REQ_NO : receivedData.vTSK_REQ_NO,
			TSK_REQ_MODI_SEQ : receivedData.vTSK_REQ_MODI_SEQ
		};

		const response:any = await CommonUtil.execute({
			url:'usr_2107',
			data: param
		})

		const result = response;
		console.log(result)
		let info = result.REC1[0];

		if(info.ELEC_APPR_YN == 'Y'){
			setElec("전자인증")
		}else if(info.FILE_ID != null){
			setElec("서면")
		}else{
			setElec("미제출")
		}

		setBizKindCd1(info.BIZ_KIND_CD_1);
		setBizKindCd2(info.BIZ_KIND_CD_2);
		setFunPurUseCd(info.FUN_PUR_USE_CD);
		setHpNo(result.HP_NO)
		setCeoNm(result.CEO_NM)
		setCorpSizeCd(result.CORP_SIZE_CD)

		setElecApprYn(info.ELEC_APPR_YN);
		setFileId(info.FILE_ID)
		setTSK_REQ_NO(info.TSK_REQ_NO);
		setTskStDate(dateToStr(info.TSK_ST_DATE));
		setTskEnDate(dateToStr(info.TSK_EN_DATE));
		setTskCloDate(dateToStr(info.TSK_CLO_DATE));
		setTskPeriod(info.TSK_PERIOD);
		setBizKindNm1(info.BIZ_KIND_NM_1);
		setBizKindNm2(info.BIZ_KIND_NM_2);
		setSuppContDivNm(info.SUPP_CONT_DIV_NM);
		setBizNm(info.BIZ_NM);
		setTskNm(info.TSK_NM);
		setSuppCorpCnt(info.SUPP_CORP_CNT);
		setOtherSuppCorpCnt(info.OTHER_SUPP_CORP_CNT);
		setTskReqDate(dateToStr(info.TSK_REQ_DATE));
		setSubYn(info.SUB_YN);
		setCloYn(info.TSK_CLO_YN);
		setTskReqStsNm(info.TSK_REQ_STS_NM);
		setTskReqStsCd(info.TSK_REQ_STS_CD);
		setFunPurUseNm(info.FUN_PUR_USE_NM)

		let foreTskYn = info.FORE_TSK_YN ? info.FORE_TSK_YN : '';
		setForeTskYn(foreTskYn);

		let question = info.QUESTION;
		if(question != null){
			let list = question.split('^||^');
			let qJson = {...qList};
			for(let i = 0; i < list.length; i++){
				qJson['q'+(i+1)] = list[i];
			}
			setQList(qJson);
		}


		setSuppCont(info.SUPP_CONT);
		setExeEffDesc(info.EXE_EFF_DESC);

		setTotalAmt(Number(info.TOT_AMT));
		setAddTotalAmt(Number(info.ADD_TOT_AMT));


		setCorpNm(result.CORP_NM);
		setBizNo(result.BIZ_NO);
		setBizCd(result.BIZ_CD);
		setCorpRegNo(result.CORP_REG_NO);
		
		if(info.TSK_PIC_PERSON_NM != null && info.TSK_PIC_PERSON_NM != ''){
			setPersonNm(info.TSK_PIC_PERSON_NM);
	  		setDeptNm(info.TSK_PIC_DEPT_NM); 
	  		setPosiNm(info.TSK_PIC_POSI_NM); 
			setEmailAdres(info.TSK_PIC_EMAIL_ADRES); 
	 		setOfcTelNo(info.TSK_PIC_OFC_TEL_NO); 
		}else{
			setPersonNm(result.PERSON_NM);
			setPosiNm(result.POSI_NM);
			setDeptNm(result.DEPT_NM);
			setEmailAdres(result.EMAIL_ADRES);
			setOfcTelNo(result.OFC_TEL_NO);
		}

		setAmtList(result.REC3);
		setCorpList(result.REC2);
		//추가과제심사금액
		setAddAmtList(result.REC4);
		
		//UA 지원금액, UD 지원기간, UE 기타변경
		setJudgeUList(result.REC8.filter(x => x.TSK_REQ_STS_CD.indexOf('U') != -1));
		setJudgeIList(result.REC8.filter(x => x.IO_DIV_CD == 'I'));
		setJudgeDList(result.REC8.filter(x => x.TSK_REQ_STS_CD == 'D'));
		setJudgeOtherList(result.REC8.filter(x => 'A,B,C,E,H'.indexOf(x.TSK_REQ_STS_CD) != -1 ));



		setCorpListText(
			result.REC2.map(function(value){
				return value.CORP_NM
			}).join(',')
		)
		// REQ - 신청서, PLAN - 계획서, 수행기관 사업자 등록증 - BIZ

		let fileList = result.FILE_INFO;
		fileValue.setTbComFileMapngDetailList([]);
		for(let i = 0; i < fileList.length; i++){
			if(fileList[i].FILE_GB == 'REQ'){
				let reqFileInfo = fileList[i];
				reqFileValue.setTbComFileMapngDetailList([]);
				//파일등록 정보
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(reqFileInfo.DWLD_ID);
				fileDetail.setFileDetailId(reqFileInfo.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(reqFileInfo.FILE_POLICY);
				fileDetail.setFileRpstr(reqFileInfo.FILE_RPSTR);
				fileDetail.setStrePath(reqFileInfo.STRE_PATH);
				fileDetail.setStreFileNm(reqFileInfo.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(reqFileInfo.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(reqFileInfo.FILE_EXTSN);
				fileDetail.setFileSize(reqFileInfo.FILE_SIZE);
				fileDetail.setRegistPsnNm(reqFileInfo.REGIST_PSN_NM);
				fileDetail.setRegistDt(reqFileInfo.REGIST_DT);
				reqFileValue.putTbComFileMapngDetailList(fileDetail);

			}else if(fileList[i].FILE_GB == 'PLAN'){
				let planFileInfo = fileList[i];
				planFileValue.setTbComFileMapngDetailList([]);
				//파일등록 정보
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(planFileInfo.DWLD_ID);
				fileDetail.setFileDetailId(planFileInfo.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(planFileInfo.FILE_POLICY);
				fileDetail.setFileRpstr(planFileInfo.FILE_RPSTR);
				fileDetail.setStrePath(planFileInfo.STRE_PATH);
				fileDetail.setStreFileNm(planFileInfo.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(planFileInfo.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(planFileInfo.FILE_EXTSN);
				fileDetail.setFileSize(planFileInfo.FILE_SIZE);
				fileDetail.setRegistPsnNm(planFileInfo.REGIST_PSN_NM);
				fileDetail.setRegistDt(planFileInfo.REGIST_DT);
				planFileValue.putTbComFileMapngDetailList(fileDetail);
			}else if(fileList[i].FILE_GB == 'BIZ'){
				let bizFileInfo = fileList[i];
				bizFileValue.setTbComFileMapngDetailList([]);
				//파일등록 정보
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(bizFileInfo.DWLD_ID);
				fileDetail.setFileDetailId(bizFileInfo.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(bizFileInfo.FILE_POLICY);
				fileDetail.setFileRpstr(bizFileInfo.FILE_RPSTR);
				fileDetail.setStrePath(bizFileInfo.STRE_PATH);
				fileDetail.setStreFileNm(bizFileInfo.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(bizFileInfo.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(bizFileInfo.FILE_EXTSN);
				fileDetail.setFileSize(bizFileInfo.FILE_SIZE);
				fileDetail.setRegistPsnNm(bizFileInfo.REGIST_PSN_NM);
				fileDetail.setRegistDt(bizFileInfo.REGIST_DT);
				bizFileValue.putTbComFileMapngDetailList(fileDetail);
			}else {
				let fileInfo = fileList[i];

				//파일등록 정보
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(fileInfo.DWLD_ID);
				fileDetail.setFileDetailId(fileInfo.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(fileInfo.FILE_POLICY);
				fileDetail.setFileRpstr(fileInfo.FILE_RPSTR);
				fileDetail.setStrePath(fileInfo.STRE_PATH);
				fileDetail.setStreFileNm(fileInfo.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(fileInfo.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(fileInfo.FILE_EXTSN);
				fileDetail.setFileSize(fileInfo.FILE_SIZE);
				fileDetail.setRegistPsnNm(fileInfo.REGIST_PSN_NM);
				fileDetail.setRegistDt(fileInfo.REGIST_DT);
				fileValue.putTbComFileMapngDetailList(fileDetail);
			}
		}

		// @ts-ignore
		if(typeof result == 'undefined'){
			alert('data is not loaded!!!')
			return;
		}
	};

	async function startCertify(){
		const result = await userRestRepository.certify("전자서명값");

		//전자인증수정
		if(result.result){
			updateElec();
		}
	}

	async function updateElec(){
		let param = {
			"TSK_REQ_NO": tskReqNo,
			"TSK_REQ_MODI_SEQ": tskReqModiSeq,
			"ELEC_APPR_YN": "Y"
		};

		const response:any = await CommonUtil.execute({
			url:'usr_2107_elec',
			data: param
		}).then((response: any) => {
			UIUtils.alert('정상처리되었습니다.').then();
			initCall();
			return;
		}).catch((error) => {
			CommonUtil.showAxiosError(error);
			return;
		});
	}



	// init
	React.useEffect(() => {
		//넘어온 파라미터 바인딩
		if(receivedData !==undefined){
			setTskReqNo(StringUtil.defaultString(receivedData.vTSK_REQ_NO));
			setTskReqModiSeq(StringUtil.defaultString(receivedData.vTSK_REQ_MODI_SEQ));
			initCall();
		}
	},[])

	async function buttonHandler(action){
		if(action == 'U'){ // 제출
			updateSub();
		} else if(action == 'D'){ // 삭제
			deleteTsk(action);
		} else if(action == 'C'){ // 변경심사
			copyTsk();
		} else if(action == 'M' || action == 'F'){ // 수정
			let msg = '수정하시겠습니까?';
			if(action === 'F') msg = '파일 업로드를 위해 수정페이지로 이동합니다.';

			if(await UIUtils.confirm(msg)){
				// let vTSK_REQ_NO = tskReqNo;
				// let vTSK_REQ_MODI_SEQ = tskReqModiSeq;
				//
				let dataToSend = {TSK_REQ_NO:tskReqNo,TSK_REQ_MODI_SEQ:tskReqModiSeq,QUE_LIST:queList,vAll_PARAM:receivedData.vAll_PARAM};

				const response:any = await CommonUtil.execute({
					url:'usr_2108',
					data: dataToSend
				})
				const info = response.REC1[0];
				await codeDataStore.read("[FPUC]", "common.suppSizeA," + info.FUN_PUR_USE_NO,"common.suppSizeB," + info.FUN_PUR_USE_NO + "," + info.BIZ_KIND_CD_1);

				// 다른 페이지로 이동하면서 데이터 전달
				history.push({
					pathname: './usr_2108',
					state: { data: {...response, ...dataToSend} }
				});
			}

		} else if(action == 'CANCEL'){
			//변경심사 삭제랑 동일한 프로세스 / 삭제 후 리스트로 갈지 이전걸 보여줄지 체크
			deleteTsk(action);
		}
	}

	function getOzReportTsk(){
		//bizNm⌋⌈•
		let tskNmTitle = '⌈'+bizNm + '⌋ 과제심사 신청서'
		let tskNmSubTitle = bizNm + ' 신청과제'

		//계획 진행 완료 체크 기준


		let st = tskStDate.substring(0, tskStDate.length-3);
		let st1 = st.substring(2,4);
		let st2 = Number(st.substring(5,7))+'';
		let st3 = Number(st.substring(8,10))+'';

		let en = tskEnDate.substring(0, tskEnDate.length-3);
		let en1 = en.substring(2,4);
		let en2 = Number(en.substring(5,7))+'';
		let en3 = Number(en.substring(8,10))+'';
		//amtList
		//수행기관 상세정보가 필요함

		let corpSizeNm = '';
		if(corpSizeCd == 'A') corpSizeNm = '대기업'
		else if(corpSizeCd == 'B') corpSizeNm = '공공기관'
		else if(corpSizeCd == 'C') corpSizeNm = '중견기업'
		else if(corpSizeCd == 'D') corpSizeNm = '중소기업'
		else if(corpSizeCd == 'E') corpSizeNm = '기타'

		let funPuerUseCd1 = '';
		let funPuerUseCd2 = '';
		if(funPurUseCd.length == 2){
			funPuerUseCd1 = funPurUseCd.substring(0,1)
			funPuerUseCd2 = funPurUseCd.substring(1,2)
		}else{
			funPuerUseCd1 = funPurUseCd;
		}

		let year = new Date().getFullYear();
		let month = new Date().getMonth()+1;
		let day = new Date().getDate();
		let judge = '';
		if(tskReqStsCd == 'A'){
			judge = '1';
		}else if(tskReqStsCd != 'H'){
			judge = '2';
		}else if(tskReqStsCd == 'H'){
			judge = '3';
		}
		let reqYn = 'N';
		let planYn = 'N';
		let bizYn = 'N';

		if(elecApprYn == 'Y' || reqFileValue.tbComFileMapngDetailList.length != 0){
			reqYn = 'Y';
		}

		if(planFileValue.tbComFileMapngDetailList.length != 0){
			planYn = 'Y';
		}

		if(bizFileValue.tbComFileMapngDetailList.length != 0){
			bizYn = 'Y';
		}



		UIUtils.openOZReportViewerPopup({
			title: "과제신청서",
			reportName: "tsk_req",
			parameter: {
				"connection.pcount": "34",
				"connection.args1": "tskNmTitle="+tskNmTitle,
				"connection.args2": "tskNmSubTitle="+tskNmSubTitle,
				"connection.args3": "corpNm="+corpNm,
				"connection.args4": "personNm="+personNm,
				"connection.args5": "deptNm="+deptNm,
				"connection.args6": "ofcTelNo="+ofcTelNo,
				"connection.args7": "hpNo="+hpNo,
				"connection.args8": "emailAdres="+emailAdres,
				"connection.args9": "corpSizeNm="+corpSizeNm,//기업사이즈코드
				"connection.args10": "tskNm="+tskNm,
				"connection.args11": "ceoNm="+ceoNm,
				"connection.args12": "suppCont="+suppCont, //지원내용, 과제개요 // as-is, to-be
				"connection.args13": "exeEffDesc="+exeEffDesc, //기대효과, 정성내용 // as-is, to-be
				"connection.args14": "bizKindCd1="+bizKindCd1,
				"connection.args15": "bizKindCd2="+bizKindCd2,
				"connection.args16": "funPuerUseCd1="+funPuerUseCd1,
				"connection.args17": "funPuerUseCd2="+funPuerUseCd2,
				"connection.args18": "corpListText="+corpListText,
				"connection.args19": "st1="+st1,
				"connection.args20": "st2="+st2,
				"connection.args21": "st3="+st3,
				"connection.args22": "en1="+en1,
				"connection.args23": "en2="+en2,
				"connection.args24": "en3="+en3,
				"connection.args25": "suppCorpCnt="+suppCorpCnt+" 개사",
				"connection.args26": "totalAmt="+StringUtil.formatNumber(Number(totalAmt)),
				"connection.args27": "totalAmtWon="+StringUtil.formatNumber(Number(totalAmt))+ ' 원',
				"connection.args28": "year="+year+'년',
				"connection.args29": "month="+month+'월',
				"connection.args30": "day="+day+'일',
				"connection.args31": "reqYn="+reqYn,
				"connection.args32": "planYn="+planYn,
				"connection.args33": "bizYn="+bizYn,
				"connection.args34": "judge="+judge,
				"odi.odinames": "tsk_req,perf_req",
				"odi.tsk_req.pcount": "2",
				"odi.tsk_req.args1": "tsk_req_no=" + tskReqNo,
				"odi.tsk_req.args2": "tsk_req_modi_seq=" + tskReqModiSeq,
				"odi.perf_req.pcount": "1",
				"odi.perf_req.args1": "tsk_req_no=" + tskReqNo,
				"information.debug":"true", // 콘솔정보(Ctrl+Z) 표시 여부
				// "toolbar.first":"true", // 첫페이지 이동 아이콘 표시
				// "toolbar.last":"true", // 마지막페이지 이동 아이콘 표시

				"pdf.fontembedding":"true", // PDF 폰트포함 (글꼴 깨지는것 방지)
				"pdf.fontembedding_subset":"true", // 폰트의 서브셋을 저장할지 여부

				"export.format":"pdf", // 저장포맷
				"export.filename": "과제신청서" + ".pdf", // 파일명
				"export.mode":"silent", // 설정창 보여줄지 여부

				"viewer.pagedisplay":"continuous", // 페이지 표시 옵션
				"viewer.viewmode":"normal", // 보고서 보기 모드
				"viewer.zoom": "90"
			},
			onClose: () => {
				console.log("Report Viewer Close");
			}
		})
	}


    function getOzReportTskNew(){//20250101이후출력물
    	
        UIUtils.openOZReportViewerPopup({
            title: "과제신청서",
            reportName: "tsk_req_new",
            parameter: {
                "connection.pcount": "2",
                "odi.odinames": "tsk_req_new",
                "odi.tsk_req_new.pcount": "2",
                "odi.tsk_req_new.args1": "tsk_req_no=" + tskReqNo,
   				"odi.tsk_req_new.args2": "tsk_req_modi_seq=" + tskReqModiSeq,
                "information.debug":"true", // 콘솔정보(Ctrl+Z) 표시 여부
                // "toolbar.first":"true", // 첫페이지 이동 아이콘 표시
                // "toolbar.last":"true", // 마지막페이지 이동 아이콘 표시

                "pdf.fontembedding":"true", // PDF 폰트포함 (글꼴 깨지는것 방지)
                "pdf.fontembedding_subset":"true", // 폰트의 서브셋을 저장할지 여부

                "export.format":"pdf", // 저장포맷
                "export.filename": "과제신청서" + ".pdf", // 파일명
                "export.mode":"silent", // 설정창 보여줄지 여부

                "viewer.pagedisplay":"continuous", // 페이지 표시 옵션
                "viewer.viewmode":"normal", // 보고서 보기 모드
                "viewer.zoom": "90"
            },
            onClose: () => {
                console.log("Report Viewer Close");
            }
        })
	}	
	
	function moveBack(){
		//window.history.back();
		// 다른 페이지로 이동하면서 데이터 전달
		let param = {};
		if(receivedData.vAll_PARAM !=undefined){
			param = JSON.parse(receivedData.vAll_PARAM);
		}

		history.push({
			pathname: './usr_2105',
			state: { data: param }
		});
	}

	const downloadButtonClickHandler = (kind:string) => {
		/*if(kind == 'REQ') CommonUtil.downloadTemplateFile("ProjectApplicationForm.hwp", "과제 신청서(양식).hwp");*/
		if(kind == 'REQ') CommonUtil.downloadTemplateFile("ProjectApplicationFormNew.hwp", "양식_과제승인신청서.hwp");
	}

	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={2} lnbIdx={1}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">과제현황</h1>

					<section className="fund-section">
						<div className="hz-root hz-gap15 mb15">
							<h3 className="section-title">과제 신청 정보</h3>
							<div className="switch-button">
								<input type="checkbox" id="switch-chk" checked={checked} onChange={(e) => checkHandled(e)} />
								<label htmlFor="switch-chk" >
									<span className="toggle"></span>
									상세보기
								</label>
							</div>
						</div>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item fo-m-1-3">
									<div className="fo-key">
										<span>과제명</span>
										<button type="button" className="button-tooltip" data-tooltip-id="tooltip1">도움말</button>
										<Tooltip
											id="tooltip1"
											disableStyleInjection={true}
											place={"bottom-start"}
											className="tooltip-conts"
										>
											<div className="msg">출연기업의 지원과제계획 제목을 작성(연도 구분 있을 시 연도 표시)</div>
										</Tooltip>
									</div>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={tskNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">과제신청번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={TSK_REQ_NO} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">진행상태</p>
									<div className="fo-value">
										{tskReqStsNm == '신청' ? ( <label className="badge badge-22 blue">신청</label> ) : '' }
										{tskReqStsNm == '접수완료' ? ( <label className="badge badge-22 green">접수완료</label> ) : '' }
										{tskReqStsNm == '수정요청' ? ( <label className="badge badge-22 yellow">수정요청</label> ) : ''}
										{tskReqStsNm == '반려' ? ( <label className="badge badge-22 red">반려</label> ) : ''}
										{tskReqStsNm == '변경심사' ? ( <label className="badge badge-22 purple">변경심사</label> ) : ''}
										{tskReqStsNm == '심사완료' ? ( <label className="badge badge-22 gray">심사완료</label> ) : ''}
									</div>
								</div>
								<div className="fo-item">
									<div className="fo-key">
										<span>과제신청일</span>
										<button type="button" className="button-tooltip" data-tooltip-id="tooltip2">도움말</button>
										<Tooltip
											id="tooltip2"
											disableStyleInjection={true}
											place={"bottom-start"}
											className="tooltip-conts"
										>
											<div className="msg">Tooltip...</div>
										</Tooltip>
									</div>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={tskReqDate} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<div className="fo-key">
										<span>과제기간</span>
										<button type="button" className="button-tooltip" data-tooltip-id="tooltip3">도움말</button>
										<Tooltip
											id="tooltip3"
											disableStyleInjection={true}
											place={"bottom-start"}
											className="tooltip-conts"
										>
											<div className="msg">
												<h6 className="tooltip-title">과제 운영기간(최대 1년), 사업기갑 변경 시 과제변경 신청 필수</h6>
												<span className="fc-pri">(사업기간 내 사업 운영 및 비용 집행)</span> <br />
												모든 제출 증빙자료의 발행일자가 고제 기간 내에 포함될 수 있도록 설정 바랍니다.<br />ex) 견적서, 세금계선서, 이체확인증 등<br />
												<p className="mt5">※ 해당연도 지급 요청 마감은 매년 11월 30일 18:00까지이며 이후 당해연도 내 추가 지급신청 불가.</p>
											</div>
										</Tooltip>
									</div>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={tskStDate +' ~ ' +  tskEnDate + ' ('+ tskPeriod + ')'} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">제출여부</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={subYn} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">전자인증 여부</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={elec} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">과제종료여부</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={cloYn} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item ">
									<p className="fo-key">과제종료일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={tskCloDate} placeholder={''} readOnly={true} />
									</div>
								</div>
								{/* 유형 type */}
								<div className="fo-rs-tit row6">유형</div>
								<div className="fo-item fo-item-rs">
									<p className="fo-key">사업분류</p>
									<div className="fo-value"><UIInput className={'tf tf-md w100p'} value={bizNm} placeholder={''} readOnly={true} /></div>
								</div>
								<div className="fo-item">
									<div className="fo-key">
										<span>기금사용용도</span>
										<button type="button" className="button-tooltip" data-tooltip-id="tooltip4">도움말</button>
										<Tooltip
											id="tooltip4"
											disableStyleInjection={true}
											place={"bottom-start"}
											className="tooltip-conts"
										>
											<div className="msg">[참고] 상생협력기금 사용용도 분류표’를 참조하여 해당하는 번호를 기입</div>
										</Tooltip>
									</div>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={funPurUseNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item fo-item-rs">
									<p className="fo-key">과제분야(대분류)</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={bizKindNm1} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">과제분야(소분류)</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={bizKindNm2} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">기금정산방식</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={foreTskYn === 'Y' ? "선지급" : "사후정산"} placeholder={''} readOnly={true} />
									</div>
								</div>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<div className="hz-root hz-gap5 mb15">
							<h3 className="section-title">지원내용 및 기대효과</h3>
							<button type="button" className="button-tooltip" data-tooltip-id="tooltip5">도움말</button>
							<Tooltip
								id="tooltip5"
								disableStyleInjection={true}
								place={"bottom-start"}
								className="tooltip-conts"
							>
								<div className="msg">지원계획 내용과 지원을 통해 기대되는 효과 기입</div>
							</Tooltip>
						</div>
						<form name="" action="" method="" className=" mb30">
							<div className="tb tb-narrow mb15">
								<table>
									<caption></caption>
									<colgroup>
										<col width="200px" />
										<col />
									</colgroup>
									<tbody>
									<tr>
										<th scope="row"><span className="th-req">과제개요</span></th>
										<td>
											<div className="ta-group w100p">
												{suppCont}
											</div>
										</td>
									</tr>
									<tr>
										<th scope="row" ><span className="th">정성효과</span></th>
										<td>
											<div className="ta-group w100p">
												{exeEffDesc}
											</div>
										</td>
									</tr>

									<tr>
										<th scope="row">기대효과</th>
										<td>
											<div className="fo fo-col2">
												<div className="inner">
													{ queList.length != 0 && queList.map((que, idx) => (
														<div className="fo-item" key={que.QUA_ID}>
															<p className="fo-key">{ que.QUA_TEXT }</p>
															<div className="fo-value">
																<UIInput className={'tf tf-md  w100p'} value={que.VALUE} readOnly={true}/>
															</div>
														</div>
													))}

												</div>
											</div>
										</td>
									</tr>
									</tbody>
								</table>
							</div>
						</form>
					</section>
					<section className={checked ? 'fund-section' : 'fund-section simply'}>
						<h3 className="section-title mb15">지원대상</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<div className="fo-key">
										<span>중소기업 지원 수</span>
										<button type="button" className="button-tooltip" data-tooltip-id="tooltip6">도움말</button>
										<Tooltip
											id="tooltip6"
											disableStyleInjection={true}
											place={"bottom-start"}
											className="tooltip-conts"
										>
											<div className="msg">수혜받는 중소기업 수를 기입</div>
										</Tooltip>
									</div>
									<div className="fo-value">
										<div className="hz-root hz-gap5">
											<UIInput className={'tf tf-md ta-right w100p'} value={suppCorpCnt} placeholder={''} readOnly={true} />
											<p className="tx-msg hz-item">개사</p>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">중소기업 외 지원 수</p>
									<div className="fo-value">
										<div className="hz-root hz-gap5">
											<UIInput className={'tf tf-md ta-right w100p'} value={otherSuppCorpCnt} placeholder={''} readOnly={true} />
											<p className="tx-msg hz-item">개사</p>
										</div>
									</div>
								</div>
								{ corpListText != '' &&
									<div className="fo-item fo-m-1-3">
										<div className="fo-key">
											<span>수행기관</span>
											<button type="button" className="button-tooltip" data-tooltip-id="tooltip61">도움말</button>
											<Tooltip
												id="tooltip61"
												disableStyleInjection={true}
												place={"bottom-start"}
												className="tooltip-conts"
											>
												<div className="msg">
													효율적인 사업수행을 위하여 출연기업이 선정한 대행기관(기업)을 의미하며, <br />
													협력재단이 수행기관에게 직접 지급하는 경우에만 사업자등록증의 상호명을 기입<br />
													(수행기관 변경 및 추가 시 사업변경 신청 필수)
												</div>
											</Tooltip>
										</div>
										<div className="fo-value">
											<UIInput className={'tf tf-md w100p'} value={corpListText} placeholder={''} readOnly={true} />
										</div>
									</div>
								}
							</div>
						</form>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">지원 항목 별 지원금</h3>
						<form name="" action="" method="">
							<div className="tb tb-narrow">
								<table>
									<caption></caption>
									<colgroup>
										<col width="400px" />
										<col width="400px" />
										<col width="400px" />
										<col />
									</colgroup>
									<thead>
									<tr>
										<th scope="col">지원항목</th>
										<th scope="col">산출근거</th>
										<th scope="col">증빙방법</th>
										<th scope="col">금액(원)</th>
									</tr>
									</thead>
									<tbody>
									{amtList.map((amt, idx) => (
										<tr key={idx}>
											<td>
												<UIInput className={'tf ta-center tf-md w100p'} value={amt.SUPP_ITEM} placeholder={''} readOnly={true} />
											</td>
											<td>
												<UIInput className={'tf ta-center tf-md w100p'} value={amt.CALC_BASIS} placeholder={''} readOnly={true} />
											</td>
											<td>
												<UIInput className={'tf ta-center tf-md w100p'} value={amt.PROF_MATH} placeholder={''} readOnly={true} />
											</td>
											<td>
												<div className="tf-unit d-block ">
													<UIInput className={'tf tf-md w100p ta-right'} value={StringUtil.formatNumber(Number(amt.SUPP_AMT)) || ""} placeholder={''} readOnly={true} />
													<span className="u">원</span>
												</div>
											</td>
										</tr>
									))}
									</tbody>
								</table>
							</div>
						</form>
						<div className="tb-total">
							<div className="tb-total-items">지원 항목별 합계금액(원)</div>
							<div className="tb-total-items">
								<div className="fund-form-items tf-unit">
									<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(totalAmt)) || "0"} placeholder={''}  readOnly={true}/>
									<span className="u">원</span>
								</div>
								<p className="tx-msg"><span className="fc-pri">({StringUtil.isNotEmpty(totalAmt + "") ?
									StringUtil.numKorPattern(totalAmt) + " 원" : "원"})</span></p>
							</div>
						</div>
					</section>
					{addAmtList.length > 0 &&
					<section className="fund-section">
						<h3 className="section-title mb15">출연잔액 외 추가과제승인 신청금액</h3>
						<form name="" action="" method="">
							<div className="tb tb-narrow">
								<table>
									<caption></caption>
									<colgroup>
										<col width="400px" />
										<col width="400px" />
										<col width="400px" />
										<col />
									</colgroup>
									<thead>
									<tr>
										<th scope="col">지원항목</th>
										<th scope="col">산출근거</th>
										<th scope="col">증빙방법</th>
										<th scope="col">금액(원)</th>
									</tr>
									</thead>
									<tbody>
									{addAmtList.map((amt, idx) => (
										<tr key={idx}>
											<td>
												<UIInput className={'tf ta-center tf-md w100p'} value={amt.ADD_SUPP_ITEM} placeholder={''} readOnly={true} />
											</td>
											<td>
												<UIInput className={'tf ta-center tf-md w100p'} value={amt.ADD_CALC_BASIS} placeholder={''} readOnly={true} />
											</td>
											<td>
												<UIInput className={'tf ta-center tf-md w100p'} value={amt.ADD_PROF_MATH} placeholder={''} readOnly={true} />
											</td>
											<td>
												<div className="tf-unit d-block ">
													<UIInput className={'tf tf-md w100p ta-right'} value={StringUtil.formatNumber(Number(amt.ADD_SUPP_AMT)) || ""} placeholder={''} readOnly={true} />
													<span className="u">원</span>
												</div>
											</td>
										</tr>
									))}
									</tbody>
								</table>
							</div>
						</form>
						<div className="tb-total">
							<div className="tb-total-items">지원 항목별 합계금액(원)</div>
							<div className="tb-total-items">
								<div className="fund-form-items tf-unit">
									<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(addTotalAmt)) || "0"} placeholder={''}  readOnly={true}/>
									<span className="u">원</span>
								</div>
								<p className="tx-msg"><span className="fc-pri">({StringUtil.isNotEmpty(addTotalAmt + "") ?
									StringUtil.numKorPattern(addTotalAmt) + " 원" : "원"})</span></p>
							</div>
						</div>
					</section>
					}
					<section className="fund-section">
						<div className="hz-root hz-sb mb15">
							<div className="hz-root hz-gap5">
								<h3 className="section-title">첨부파일</h3>
								<button type="button" className="button-tooltip" data-tooltip-id="tooltip7">도움말</button>
								<Tooltip
									id="tooltip7"
									disableStyleInjection={true}
									place={"bottom-start"}
									className="tooltip-conts"
								>
									<div className="msg">
										<h6 className="tooltip-title">과제 신청 시 첨부 서류</h6>
										<ul>
											<li>1. 운영규정 별지 제2호 동반성장 투자재원 과제신청서(과제요약서 포함)
												<ul className="list-group">
													<li>서면 : 지급신청서(서면) 클릭하여 지급신청서 출력 후 직인을 찍고 스캔하여 첨부문서에 등록하셔야 합니다.</li>
													<li>전자인증 : 기업용 공인인증서를 이용하여 지급신청서(전자인증) 을 클릭하여 인증이 완료 되면 됩니다. <br />별도 첨부 문서는 없습니다.</li>
												</ul>
											</li>
											<li>2. 세부사업계획서(완료심사의 경우, 사업완료보고서)</li>
											<li>3. 수행기관 사업자등록증(해당시)</li>
											<li>4. 기타 심사에 필요하다고 판단되는 경우, 추가 서류를 요청 드릴 수 있습니다.</li>
										</ul>
									</div>
								</Tooltip>
							</div>
						{tskReqStsCd != 'H' &&
							<Button color='gray-o' size="sm" onClick={() => buttonHandler('F')}>첨부파일수정</Button>
						}
						</div>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								{ elecApprYn == 'N' && reqFileValue.tbComFileMapngDetailList.length == 0 &&
								<div className="fo-item fo-m-1-3 req">
										<p className="fo-key">과제 신청서</p>
										<div className="fo-value">
											<div className="fund-form-group hz-root hz-gap5">
												<div className="fund-form-items">
													<p className="tx-msg">제출이 완료되지 않았습니다. 전자인증을 하시거나 수정버튼을 선택하고 수정화면에서 파일을 업로드 해주세요.</p>
												</div>
												<Button color='pri-o' size="md" onClick={() => getOzReportTskNew()}>미리보기</Button>
												<Button color='pri-o' size="md" onClick={() => startCertify()}>전자인증</Button>
												<Button color='gray-o' size="md" onClick={() => downloadButtonClickHandler('REQ')}>양식 다운로드</Button>
											</div>
										</div>
									</div>
								}
								{ elecApprYn == 'Y' &&
								<div className="fo-item fo-m-1-3 req">
										<p className="fo-key">과제 신청서</p>
										<div className="fo-value">
											<div className="fund-form-group">
												<div className="fund-form-items">
													<p className="tx-msg">전자인증이 완료되었습니다.</p>
												</div>
												<Button color='pri-o' size="md" onClick={() => getOzReportTskNew()}>미리보기</Button>
											</div>
										</div>
									</div>
								}
								{planFileValue.tbComFileMapngDetailList.length == 0 &&
									<div className="fo-item fo-m-1-3 req">
										<p className="fo-key">과제 계획서</p>
										<div className="fo-value">
											<div className="fund-form-group">
												<div className="fund-form-items">
													<p className="tx-msg">제출이 완료되지 않았습니다. 수정버튼을 선택하고 수정화면에서 파일을 업로드 해주세요.</p>
												</div>
											</div>
										</div>
									</div>
								}
								{ bizFileValue.tbComFileMapngDetailList.length == 0 && corpListText != '' &&
									<div className="fo-item fo-m-1-3 req">
										<p className="fo-key">수행기관 사업자 등록증<br />(수행기관 해당시만)</p>
										<div className="fo-value">
											<p className="tx-msg">제출이 완료되지 않았습니다. 수정버튼을 선택하고 수정화면에서 파일을 업로드 해주세요.</p>
										</div>
									</div>
								}

								{reqFileValue.tbComFileMapngDetailList.length != 0 && elecApprYn == 'N' &&
									<div className="fo-item fo-m-1-3 req">
										<p className="fo-key">과제 신청서</p>
										<div className="fo-value">
											<div className="fund-form-group">
                                                <div className="fund-form-items">										
													<UI.FileDownloadSimpleMode value={reqFileValue} viewMode={"fund-download"}/>
												</div>
												<Button color='pri-o' size="md" onClick={() => startCertify()}>전자인증</Button>
											</div>
										</div>
									</div>
								}
								{planFileValue.tbComFileMapngDetailList.length != 0 &&
									<div className="fo-item fo-m-1-3 req">
										<p className="fo-key">과제 계획서</p>
										<div className="fo-value">
											<UI.FileDownloadSimpleMode value={planFileValue} viewMode={"fund-download"}/>
										</div>
									</div>
								}
								{ bizFileValue.tbComFileMapngDetailList.length != 0 && corpListText != '' &&
									<div className="fo-item fo-m-1-3">
										<p className="fo-key">수행기관 사업자 등록증<br />(수행기관 해당시만)</p>
										<div className="fo-value">
											<UI.FileDownloadSimpleMode value={bizFileValue} viewMode={"fund-download"}/>
										</div>
									</div>
								}
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">첨부파일</p>
									<div className="fo-value">
										<div className='w100p'>
											<UI.FileDownload
												value={fileValue}
												className={'w100p'}
											/>
										</div>
									</div>
								</div>
							</div>
						</form>
						{/* FileUpload... */}
						{/*<Raonkupload />*/} {/* 기능X css 디자인 ☆Fileupload 영역입니다☆ */}
					</section>
					<section className={checked ? 'fund-section' : 'fund-section simply'}>
						<h3 className="section-title mb15">심사변경이력</h3>
						<form name="" action="" method="">
							<div className="tb tb-narrow">
								<table>
									<caption></caption>
									<colgroup>
										<col />
										<col width="20%" />
										<col width="20%" />
										<col width="40%" />
									</colgroup>
									<thead>
									<tr>
										<th scope="col">구분</th>
										<th scope="col">기존</th>
										<th scope="col">변경</th>
										<th scope="col">사유</th>
									</tr>
									</thead>
									<tbody>
									{
										judgeUList.length != 0 ? judgeUList.map((judge, idx) => {
												return (
													<tr key={idx}>
														{judge.TSK_REQ_STS_CD == 'UA' &&
															<td>
																<UIInput className={'tf tf-md w100p ta-center'} value={'지원금액 변경'} placeholder={''} readOnly={true}/>
															</td>
														}
														{judge.TSK_REQ_STS_CD == 'UD' &&
															<td>
																<UIInput className={'tf tf-md w100p ta-center'} value={'지원기간 변경'} placeholder={''} readOnly={true}/>
															</td>
														}
														{judge.TSK_REQ_STS_CD == 'UE' &&
															<td>
																<UIInput className={'tf tf-md w100p ta-center'} value={'기타 변경 사유'} placeholder={''} readOnly={true}/>
															</td>
														}
														{judge.TSK_REQ_STS_CD == 'UE' &&
															<td colSpan={3}>
																{
																	judge.JUDGE_CMT.split('\n').map((cmt) => {
																		return (
																			<span>
																				{cmt}
																				<br/>
																			</span>
																		);
																	})
																}
															</td>
														}
														{judge.TSK_REQ_STS_CD == 'UD' &&
															<td>{judge.OLD_DATA}</td>
														}
														{judge.TSK_REQ_STS_CD == 'UA' &&
															<td>{StringUtil.formatNumber(Number(judge.OLD_DATA)) || "0"}<span className="u">원</span></td>
														}
														{judge.TSK_REQ_STS_CD == 'UD' &&
															<td>{judge.NEW_DATA}</td>
														}
														{judge.TSK_REQ_STS_CD == 'UA' &&
															<td>{StringUtil.formatNumber(Number(judge.NEW_DATA)) || "0"}<span className="u">원</span></td>
														}
														{judge.TSK_REQ_STS_CD != 'UE' &&
															<td>
																{
																	judge.JUDGE_CMT.split('\n').map((cmt) => {
																		return (
																			<span>
																				{cmt}
																				<br/>
																			</span>
																		);
																	})
																}
															</td>
														}
													</tr>
												)
											}) :
											<tr>
												<td colSpan={4}>
													<div className="nd">
													<p className="tx tx-cp2 fc-666">내역이 없습니다.</p>
													</div>
												</td>
											</tr>
									}
									</tbody>
								</table>
							</div>
						</form>
					</section>
					<section className={checked ? 'fund-section' : 'fund-section simply'}>
						<h3 className="section-title mb15">반려사유</h3>
						<form name="" action="" method="">
							<div className="tb tb-narrow">
								<table>
									<caption></caption>
									<colgroup>
										<col width="90px" />
										<col />
										<col width="230px" />
									</colgroup>
									<thead>
									<tr>
										<th scope="col">순번</th>
										<th scope="col">반려사유</th>
										<th scope="col">재단담당자명</th>
									</tr>
									</thead>
									<tbody>
									{
										judgeDList.length != 0 ? judgeDList.map((judge, idx) => (
												<tr key={idx}>
													<td>{idx + 1}</td>
													<td>{
														judge.JUDGE_CMT.split('\n').map((cmt) => {
															return (
																<span>
																{cmt}
																<br/>
														  		</span>
															);
														})
													}</td>
													<td>{judge.REG_USERNM}</td>
												</tr>
											)) :
											<tr>
												<td colSpan={3}>
													<div className="nd">
														<p className="tx tx-cp2 fc-666">내역이 없습니다.</p>
													</div>
												</td>
											</tr>
									}
									</tbody>
								</table>
							</div>
						</form>
					</section>
					<section className={checked ? 'fund-section' : 'fund-section simply'}>
						<h3 className="section-title mb15">심사의견</h3>
						<form name="" action="" method="">
							<div className="tb tb-narrow">
								<table>
									<caption></caption>
									<colgroup>
										<col width="90px" />
										<col width="230px" />
										<col />
										<col width="130px" />
										<col width="130px" />
										<col width="230px" />
									</colgroup>
									<thead>
									<tr>
										<th scope="col">순번</th>
										<th scope="col">심사진행상태</th>
										<th scope="col">심사의견</th>
										<th scope="col">소속기관</th>
										<th scope="col">담당자명</th>
										<th scope="col">업무처리일자</th>
									</tr>
									</thead>
									<tbody>
									{
										judgeOtherList.length != 0 ? judgeOtherList.map((judge, idx) => (
												<tr key={idx}>
													<td>{idx + 1}</td>
													<td>{judge.TSK_REQ_STS_NM}</td>
													<td>{
														judge.JUDGE_CMT.split('\n').map((cmt) => {
															return (
																<span>
																{cmt}
																<br/>
														  </span>
															);
														})
													}</td>
													<td>{judge.CORP_NM}</td>
													<td>{judge.REG_USERNM}</td>
													<td>{judge.JUDGE_DATE}</td>
												</tr>
											)) :
											<tr>
												<td colSpan={6}>
													<div className="nd">
														{/* <i className="ic"></i> */} {/* [M.20240522]삭제 */}
														<p className="tx tx-cp2 fc-666">내역이 없습니다.</p>
													</div>
												</td>
											</tr>
									}
									</tbody>
								</table>
							</div>
						</form>
					</section>
					<section className={checked ? 'fund-section' : 'fund-section simply'}>
						<h3 className="section-title mb15">기업 정보</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">기업명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">법인사업자번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpRegNo} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">사업자번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={StringUtil.bizCrpFormat(bizNo)} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">담당자</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={personNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">직급</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={posiNm} placeholder={''} readOnly={true}  />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">부서</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={deptNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">이메일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={emailAdres} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">전화번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={StringUtil.telephoneFormat(ofcTelNo)} placeholder={''} readOnly={true}  />
									</div>
								</div>
							</div>
						</form>
					</section>
					{/*버튼목록*/}
					{/*
					신청	A
					접수완료	B
					수정요청	C
					반려	D
					변경심사	E
					심사완료	H
					*/}
					<div className="hz-root hz-right hz-gap10 mt30">
						{ subYn === '미제출' && tskReqStsCd === 'A' &&
							<div className="hz-root hz-right hz-gap10 mt30">
								<Button color="pri" size="md" onClick={() => buttonHandler('U')}>제출</Button>
								<Button color="pri-o2" size="md" onClick={() => buttonHandler('M')}>수정</Button>
								<Button color="pri" size="md" onClick={() => buttonHandler('D')}>삭제</Button>
								<Button color="gray-o" size="md" onClick={() => moveBack()}>목록</Button>
							</div>
						}
						{ subYn === '미제출' && tskReqStsCd === 'D' &&
							<div className="hz-root hz-right hz-gap10 mt30">
								<Button color="pri" size="md" onClick={() => buttonHandler('D')}>삭제</Button>
								<Button color="gray-o" size="md" onClick={() => moveBack()}>목록</Button>
							</div>
						}
						{ subYn === '미제출' && tskReqStsCd === 'C' &&
							<div className="hz-root hz-right hz-gap10 mt30">
								<Button color="pri" size="md" onClick={() => modalusr2107p.open()}>제출</Button>
								<Button color="pri-o2" size="md" onClick={() => buttonHandler('M')}>수정</Button>
								<Button color="pri" size="md" onClick={() => buttonHandler('D')}>삭제</Button>
								<Button color="gray-o" size="md" onClick={() => moveBack()}>목록</Button>
							</div>
						}
						{ subYn === '미제출' && tskReqStsCd === 'E' &&
							<div className="hz-root hz-right hz-gap10 mt30">
								<Button color="pri" size="md" onClick={() => buttonHandler('U')}>제출</Button>
								<Button color="pri-o2" size="md" onClick={() => buttonHandler('M')}>수정</Button>
								<Button color="gray-o" size="md" onClick={() => buttonHandler('CANCEL')}>변경심사취소</Button>
								<Button color="gray-o" size="md" onClick={() => moveBack()}>목록</Button>
							</div>
						}
						{ subYn === '제출' && tskReqStsCd === 'H' &&
							<div className="hz-root hz-right hz-gap10 mt30">
							{ cloYn !== '종결' &&
								<Button color="pri-o2" size="md" onClick={() => buttonHandler('C')}>변경심사</Button>
							}
								<Button color="gray-o" size="md" onClick={() => moveBack()}>목록</Button>
							</div>
						}
						{ subYn === '제출' && tskReqStsCd === 'D' &&
							<div className="hz-root hz-right hz-gap10">
								<Button color="pri" size="md" onClick={() => buttonHandler('D')}>삭제</Button>
								<Button color="gray-o" size="md" onClick={() => moveBack()}>목록</Button>
							</div>
						}
						{ subYn === '제출' && tskReqStsCd === 'A' &&
							<div className="hz-root hz-right hz-gap10 mt30">
								<Button color="gray-o" size="md" onClick={() => moveBack()}>목록</Button>
							</div>
						}
						{ subYn === '제출' && tskReqStsCd === 'B' &&
							<div className="hz-root hz-right hz-gap10 mt30">
								<Button color="gray-o" size="md" onClick={() => moveBack()}>목록</Button>
							</div>
						}
						{ subYn === '제출' && tskReqStsCd === 'C' &&
							<div className="hz-root hz-right hz-gap10 mt30">
								<Button color="gray-o" size="md" onClick={() => moveBack()}>목록</Button>
							</div>
						}
						{ subYn === '제출' && tskReqStsCd === 'E' &&
							<div className="hz-root hz-right hz-gap10 mt30">
								<Button color="gray-o" size="md" onClick={() => moveBack()}>목록</Button>
							</div>
						}
					</div>
				</main>
			</div>
			
			{/* modal - 2107p */}
			<ModalPopup
				open={modalusr2107p.isShowing}
				title="수정사항"
				size="sm"
				onClose={() => {modalusr2107p.close(); setJudgeCmt('');}}
			>
				<div className="modal-con">
					<div className="ta h130 w100p mb10">
						{/*<textarea readOnly className="ta-ip" placeholder=""></textarea>*/}
						<UITextArea className={'ta-ip'} value={judgeCmt} valueChanged={(value) => {setJudgeCmt(value)}} />
					</div>
				</div>
				<div className="modal-bottom">
					<div className="hz-root hz-gap8">
						<Button color='gray-o' size="md" onClick={() => {modalusr2107p.close(); setJudgeCmt('');}}>취소</Button>
						<Button color='pri' size="md" onClick={() => updateSub()}>제출</Button>
					</div>
				</div>
			</ModalPopup>
		</PageContainer>
	);
}
export default ContentsContainer;